export default __webpack_public_path__ + "static/media/xrp1-gj.74484862.webp";